import React from "react";
import { ListSubheader, MenuItem, Typography } from "@mui/material";
import _ from "lodash";

const NO_STORE = "Sin local";

// Etiqueta de un dispositivo con su local: dos locales pueden tener un «Pasillo 1-1».
export const deviceOptionLabel = (device) => {
    if (!device) return "";
    return device.store_name ? `${device.name} · ${device.store_name}` : device.name;
};

// Opciones de un select de dispositivos agrupadas por local (los sin local al final), cada una con su zona. Con un solo
// local no agrega encabezados. renderLabel permite cambiar el texto de cada opción (por ejemplo, para avisar que está
// deshabilitada).
export const groupedDeviceOptions = ({ devices, keyPrefix, isDisabled = () => false, renderLabel = (device) => device.name }) => {
    const groups = _.sortBy(
        _.toPairs(_.groupBy(devices, (device) => device.store_name || NO_STORE)),
        ([store]) => [store === NO_STORE ? 1 : 0, store.toLowerCase()],
    );
    const withHeaders = groups.length > 1;

    return groups.flatMap(([store, storeDevices]) => [
        withHeaders && (
            <ListSubheader key={`${keyPrefix}-store-${store}`} sx={{ lineHeight: "32px", fontWeight: 700, color: "text.primary" }}>
                {store}
            </ListSubheader>
        ),
        ...storeDevices.map((device) => (
            <MenuItem key={`${keyPrefix}-${device.id}`} value={device.id} disabled={isDisabled(device)} sx={withHeaders ? { pl: 3 } : undefined}>
                {renderLabel(device)}
                {device.zone && (
                    <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                        {device.zone}
                    </Typography>
                )}
            </MenuItem>
        )),
    ].filter(Boolean));
};
